// ESM-Huelle fuer lib/scripts/pos/components/CMP_CCustomerAdmin.js (ESM-Welle 5a).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from '../components/component.js';

function CCustomerAdmin(id) {
    this.construct(id,"CCustomerAdmin");

    this.htmlType = "div";

    this.properties = {
        styles: {
            position: "absolute",
            width: "100%",
            height: "100%",
            left: "0px",
            top: "0px",
            zIndex: "2",
            backgroundColor: "#DFDFDF"
        }
    }

    this.Main = null;
    this.foundCustomers = new Array("custId", "custName");
    this.foundCustomers.custId = new Array();
    this.foundCustomers.custName = new Array();
    this.registerStep = 0;
    this.newCustomer = new Array();
}

CCustomerAdmin.prototype = new CComponent;

CCustomerAdmin.prototype.prepare = function() {
    var xml = new CXmlHandler("etc/layout/LYT_customerAdmin.xml");

    this.createChildrenFromXML(xml);

    this.Main = POS.sessions.getSessionComponent();

    this.components.titleContainer.components.cancelButton.properties.events.onMousedown = this.cancel;
    this.components.titleContainer.components.cancelButton.properties.attributes.onMousedown_parameter_0 = this.id;

    this.Main.disableInputFocus();

    this.components.searchButtons.buttons = this.makeSearchButtons();
    this.components.functionButtons.buttons = this.makeFunctionButtons();

    this.components.scroll.components.scrollUp.properties.events.onMousedown = this.scroll;
    this.components.scroll.components.scrollUp.properties.attributes.onMousedown_parameter_0 = this.id;
    this.components.scroll.components.scrollUp.properties.attributes.onMousedown_parameter_1 = -30;

    this.components.scroll.components.scrollDown.properties.events.onMousedown = this.scroll;
    this.components.scroll.components.scrollDown.properties.attributes.onMousedown_parameter_0 = this.id;
    this.components.scroll.components.scrollDown.properties.attributes.onMousedown_parameter_1 = 30;

    this.components.overlay.components.backButton.properties.caption.value = "&lt;";
    this.components.overlay.components.backButton.properties.events.onMousedown = this.stepBack;
    this.components.overlay.components.backButton.properties.attributes.onMousedown_parameter_0 = this.id;
    this.components.overlay.components.backButton.prepare();

    this.components.overlay.components.okButton.properties.caption.value = ">";
    this.components.overlay.components.okButton.properties.events.onMousedown = this.stepForward;
    this.components.overlay.components.okButton.properties.attributes.onMousedown_parameter_0 = this.id;
    this.components.overlay.components.okButton.prepare();

    this.components.overlay.components.cancelButton.properties.events.onMousedown = this.cancelInput;
    this.components.overlay.components.cancelButton.properties.attributes.onMousedown_parameter_0 = this.id;

    this.highlight(0);

    this.baseSQL = "SELECT Barcode, FirstName, Surname, ZIP FROM CUST WHERE %where% ORDER BY Surname LIMIT 100";
    this.resetSQLConditions();

    this.prepared = true;
}

CCustomerAdmin.prototype.resetSQLConditions = function() {
    this.SQLConditions = Array();
    this.SQLConditions["FirstName"] = "";
    this.SQLConditions["Surname"] = "";
    this.SQLConditions["Barcode"] = "";
    this.SQLConditions["ZIP"] = "";
}

CCustomerAdmin.prototype.getSQLQuery = function() {
    var sqlWhere = "";
    for (var sqlField in this.SQLConditions) {
        if (this.SQLConditions[sqlField]) {
            var sWhere = sqlField + " " + umlauToEntity(this.SQLConditions[sqlField]);
            if (sqlWhere)
                sqlWhere = sWhere + " OR " + sqlWhere;
            else
                sqlWhere = sWhere;
        }
    }

    return this.baseSQL.replace("%where%", sqlWhere);
}

CCustomerAdmin.prototype.highlight = function(mode) {
    switch (mode) {
        case 0:
            var modeText = "TITLE";
            break;
        case 1:
            modeText = "FIRST_NAME";
            break;
        case 2:
            modeText = "SURNAME";
            break;
        case 3:
            modeText = "ADDRESS";
            break;
        case 4:
            modeText = "ZIP";
            break;
        case 5:
            modeText = "CITY";
            break;
        case 6:
            modeText = "COUNTRY";
            break;
        case 7:
            modeText = "TELEPHONE";
            break;
        case 8:
            modeText = "FAX";
            break;
        case 9:
            modeText = "EMAIL";
            break;
        case 10:
            modeText = "BLUE_ID";
            break;
        default:
            modeText = "none";
    }

    var text =
        POS.lang.getText("LABELS", "TITLE") + ":<br>" +
        POS.lang.getText("LABELS", "FIRST_NAME") + " / " +
        POS.lang.getText("LABELS", "SURNAME") + ":<br>" +
        POS.lang.getText("LABELS", "ADDRESS") + ":<br>" +
        POS.lang.getText("LABELS", "ZIP") + " / " +
        POS.lang.getText("LABELS", "CITY") + ":<br>" +
        POS.lang.getText("LABELS", "COUNTRY") + ":<br>" +
        POS.lang.getText("LABELS", "TELEPHONE") + ":<br>" +
        POS.lang.getText("LABELS", "FAX") + ":<br>" +
        POS.lang.getText("LABELS", "EMAIL") + ":<br>" +
        POS.lang.getText("LABELS", "BLUE_ID") + ":";

    if (mode != "none") {
        var textToReplace = POS.lang.getText("LABELS", modeText);

        text = text.replace(textToReplace, "<span style='color:#FF0000'>" +
            textToReplace + "</span>");
    }

    this.components.overlay.components.labels.properties.value = text;
    this.components.overlay.components.labels.reValue();
}

CCustomerAdmin.prototype.redrawData = function() {
    var text = "";

    for (var i = 0; i < this.newCustomer.length; i++) {
        if (i == 1 || i == 4)
            text += this.newCustomer[i] + " ";
        else
            text += this.newCustomer[i] + "<br>";
    }

    this.components.overlay.components.data.properties.value = text;
    this.components.overlay.components.data.reValue();
}

CCustomerAdmin.prototype.cancelInput = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.newCustomer = new Array();
    me.components.overlay.components.data.properties.value = "";
    me.components.overlay.components.data.reValue();
    me.components.inputField.field.input.properties.attributes.value = "";
    me.components.inputField.field.input.reAttribute();
    me.registerStep = 0;
    me.highlight(0);
    me.removeInput();
}

CCustomerAdmin.prototype.scroll = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.components.listContainer.scroll(parameters[1]);
}

CCustomerAdmin.prototype.makeSearchButtons = function() {
    var btns = new Array();

    btns[0] = new CPushButton(this.id);
    btns[0].properties.caption.value = POS.lang.getText("BUTTONS", "CUSTOMER_NAME_SEARCH");
    btns[0].properties.attributes.onMousedown_parameter_0 = this.id;
    btns[0].properties.attributes.onMousedown_parameter_1 = "bon";
    if (typeof POS.EnvProperties.CUSTOMERNAMESEARCH != "undefined" && POS.EnvProperties.CUSTOMERNAMESEARCH == "YES") {
        btns[0].properties.events.onMousedown = this.customerSearch;
        var customerSearch = true;
    } else
        customerSearch = false;
    btns[0].setEnabled(customerSearch);

    btns[1] = new CPushButton(this.id);
    btns[1].properties.caption.value = POS.lang.getText("BUTTONS", "CUSTOMER_NUMBER_SEARCH");
    btns[1].properties.events.onMousedown = this.numberSearch;
    btns[1].properties.attributes.onMousedown_parameter_0 = this.id;
    btns[1].properties.attributes.onMousedown_parameter_1 = "Barcode";

    btns[2] = new CPushButton(this.id);
    btns[2].properties.caption.value = POS.lang.getText("BUTTONS", "ZIP_SEARCH");
    btns[2].properties.events.onMousedown = this.numberSearch;
    btns[2].properties.attributes.onMousedown_parameter_0 = this.id;
    btns[2].properties.attributes.onMousedown_parameter_1 = "ZIP";

    return btns;
}

CCustomerAdmin.prototype.prepareInput = function() {
    this.components.searchButtons.setEnabled(false);
    this.components.functionButtons.setEnabled(false);
    this.components.overlay.properties.styles.visibility = "visible";
    this.components.overlay.reStyle();

}

CCustomerAdmin.prototype.removeInput = function() {
    this.components.searchButtons.setEnabled(true);
    this.components.functionButtons.setEnabled(true);
    this.components.overlay.properties.styles.visibility = "hidden";
    this.components.overlay.reStyle();
}

CCustomerAdmin.prototype.makeFunctionButtons = function() {
    var btns = new Array();

    for (var i = 0; i < 2; i++) {
        btns[i] = new CPushButton(this.id);
        btns[i].properties.attributes.onMousedown_parameter_0 = this.id;
    }

    btns[0].properties.caption.value = POS.lang.getText("BUTTONS", "CHOOSE_CUSTOMER");
    btns[0].properties.events.onMousedown = this.chooseCustomer;
    btns[0].properties.styles.backgroundColor = "#BBF3BB";
    btns[0].properties.styles.borderColor = "#77CC77";

    btns[1].properties.caption.value = POS.lang.getText("BUTTONS", "RESET_SEARCH");
    btns[1].properties.events.onMousedown = this.resetSearch;
    btns[1].properties.styles.backgroundColor = "#FFC57A";
    btns[1].properties.styles.borderColor = "#FF8204";

    return btns;
}

CCustomerAdmin.prototype.addCustomer = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.components.inputField.field.input.properties.attributes.value = "";
    me.components.inputField.field.input.reAttribute();

    me.resetList();
    me.prepareInput();
}

CCustomerAdmin.prototype.stepBack = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.components.inputField.field.input.properties.attributes.value = "";
    me.components.inputField.field.input.reAttribute();

    me.registerStep--;
    if (me.registerStep < 0)
        me.registerStep = 0;

    me.highlight(me.registerStep);

    me.components.inputField.field.input.properties.attributes.value =
        me.newCustomer[me.registerStep];
    me.components.inputField.field.input.reAttribute();

    me.redrawData();
}

CCustomerAdmin.prototype.stepForward = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);
    var CustomerAdminClass = this;
    var userInput = me.components.inputField.field.input.properties.attributes.value;
    if (userInput[userInput.length - 1] == " ")
        userInput = userInput.slice(0, [userInput.length - 1]);
    me.components.inputField.field.input.properties.attributes.value = "";
    me.components.inputField.field.input.reAttribute();

    if (typeof me.newCustomer[me.registerStep] != "undefined") {
        var oldValue = me.newCustomer[me.registerStep];
        if (typeof me.newCustomer[me.registerStep + 1] != "undefined") {
            me.components.inputField.field.input.properties.attributes.value =
                me.newCustomer[me.registerStep + 1];
            me.components.inputField.field.input.reAttribute();
        }
    } else
        oldValue = null;

    //    if (userInput == "" && !oldValue && me.registerStep != 11)
    //        return;

    if (userInput) {
        if (me.registerStep == 9)
            userInput = userInput.toLowerCase();
        else if (me.registerStep == 0 && userInput == "DI")
            userInput = userInput;
        else
            userInput = toLowerCaseButFirst(userInput);
    } else if (oldValue)
        userInput = oldValue;
    else
        userInput = "";

    if (me.registerStep == 11) {

        var r = me.registerCustomer();
        $.when(r).then(function(idCust) {
            CustomerAdminClass.foundCustomers = new Array("custId", "custName");

            me.foundCustomers.custId[0] = expandInteger(idCust, 5);
            me.foundCustomers.custName[0] = "&nbsp;-&nbsp;" + me.newCustomer[4] +
                " / " + me.newCustomer[1] + " " + me.newCustomer[2];

            me.makeBodyList();

            me.newCustomer = new Array();
            me.components.overlay.components.data.properties.value = "";
            me.components.overlay.components.data.reValue();
            me.registerStep = 0;
            me.highlight(0);
            me.removeInput();
        });
        return;
    }

    me.newCustomer[me.registerStep] = userInput;

    me.redrawData();

    me.registerStep++;
    me.highlight(me.registerStep);
}

CCustomerAdmin.prototype.registerCustomer = function() {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var title = umlauToEntity(this.newCustomer[0]);
    var firstName = umlauToEntity(this.newCustomer[1]);
    var surname = umlauToEntity(this.newCustomer[2]);
    var address = umlauToEntity(this.newCustomer[3]);
    var ZIP = umlauToEntity(this.newCustomer[4]);
    var city = umlauToEntity(this.newCustomer[5]);
    var country = umlauToEntity(this.newCustomer[6]);
    var telephone = umlauToEntity(this.newCustomer[7]);
    var fax = umlauToEntity(this.newCustomer[8]);
    var email = umlauToEntity(this.newCustomer[9]);
    var blueId = umlauToEntity(this.newCustomer[10]);

    var sql = "INSERT INTO CUST (Rebate, Title, FirstName, Surname, Address, ZIP, " +
        "City, Country, Telephone, Fax, Email, BlueId, Barcode) VALUES (0.03, '" +
        title + "', '" + firstName + "', '" + surname + "', '" + address + "', '" +
        ZIP + "', '" + city + "', '" + country + "', '" + telephone + "', '" + fax +
        "', '" + email + "', '" + blueId + "', NULL)";
    var r1 = POS.SQLiteCon.execute(sql);
    $.when(r1).then(function() {
        var r = POS.SQLiteCon.lastInsertId("CUST_ID", "CUST");
        $.when(r).then(function(idCust) {
            var newBarcode = idCust.toString();
            newBarcode = "88" + expandInteger(newBarcode, 10);

            sql = "UPDATE CUST SET Barcode = " + newBarcode + " WHERE CUST_ID = " +
                idCust;
            POS.SQLiteCon.execute(sql);
            dfd.resolve(idCust);
            //return idCust;
        });
    });
    return dfd.promise();
}

CCustomerAdmin.prototype.deleteCustomer = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var bonGrid = me.components.listContainer.components.list;

    if (bonGrid.selectedRowIndex == -1)
        return;

    me.selectedCustomer = bonGrid.rows[bonGrid.selectedRowIndex].row.
    children[0].properties.value;

    var text = POS.lang.getText("MESSAGES", "CONF_DELETE_CUSTOMER");
    POS.message.show(text, "warning", "YESNO", me, me.doDeleteCustomer);
    return;
}

CCustomerAdmin.prototype.doDeleteCustomer = function(me, result) {
    if (result != "YES")
        return;

    /*privMan.enablePrivilege (privList);*/

    var sql = "DELETE FROM CUST WHERE CUST_ID = " + parseInt(me.selectedCustomer);

    POS.SQLiteCon.execute(sql);

    me.resetList();
}

CCustomerAdmin.prototype.chooseCustomer = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var bonGrid = me.components.listContainer.components.list;

    if (bonGrid.selectedRowIndex == -1)
        return;

    me.selectedCustomer = bonGrid.rows[bonGrid.selectedRowIndex].row.
    children[0].properties.value;
    var v = Trans.getCustomerIdFromBarcode(parseInt(me.selectedCustomer));
    //var custId = Trans.getCustomerIdFromBarcode(parseInt(me.selectedCustomer));
    $.when(v).then(function(custId) {
        me.Main.BonManager.currentCustomerId = custId;

        var r = me.Main.BonManager.updateInstantRebate();
        $.when(r).then(function() {
            if (me.Main.BonManager.currentBonId != 0) {
                var def = me.Main.BonManager.redrawAll();
            } else {
                def = 0;
            }
            $.when(def).done(function() {
                var regExpWholesaleCustomerCard = new RegExp("^222[0-9]{10}$", "g");
                if (me.selectedCustomer.match(regExpWholesaleCustomerCard) != null) {
                    /*me.Main.components.payment2.children[9].setEnabled(true);*/
                    if (me.Main.components.payment2.children[6 - me.Main.components.payment.buttons.length])
                        me.Main.components.payment2.children[6 - me.Main.components.payment.buttons.length].setEnabled(true);

                }
                me.Main.InfoIcons.highlightIcon("customer");
                var v = Trans.isObsoleteAddress(custId);
                $.when(v).then(function(val) {
                    if (val)
                        me.doObsoleteAddress(custId);

                    me.Main.vacuumInfoValue(me.Main);
                    me.finish();
                });
            });
        });
    });
}

CCustomerAdmin.prototype.printCustData = function(mode, customerData) {
    switch (mode) {
        case "OLD":
            var headText = POS.lang.getText("LABELS", "CUSTOMER_DATA_OLD");
            var lineHeight = 0;
            break;
        case "NEW":
            var headText = POS.lang.getText("LABELS", "CUSTOMER_DATA_NEW");
            var lineHeight = 3;
            break;
    }

    Printer.addLine("A", 1, false, 0);
    Printer.addElement(headText, 20, 2, true, 0, 41);
    Printer.addLine("B", 1, false, 2);

    switch (mode) {
        case "OLD":
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "NAME") + ":", 0, 0, false, 0, 10);
            Printer.addElement(customerData.firstName + " " + customerData.surname, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "ADDRESS") + ":", 0, 0, false, 0, 10);
            Printer.addElement(customerData.address, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(customerData.zip + " " + customerData.city, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "EMAIL") + ":", 0, 0, false, 0, 10);
            Printer.addElement(customerData.email, 11, 0, false, 11, 40);
            break;
        case "NEW":
            var stdLine = customerData.address;
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "BIRTHDAY") + ":", 0, 0, true, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "TITLE") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "FIRST_NAME") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "SURNAME") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "STREET") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "HOUSE_NUMBER") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "ZIP") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "CITY") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);
            Printer.addLine("A", 1, false, lineHeight);
            Printer.addElement(POS.lang.getText("LABELS", "EMAIL") + ":", 0, 0, false, 0, 10);
            Printer.addElement(stdLine, 11, 0, false, 11, 40);

	    break;
    }
}

CCustomerAdmin.prototype.doObsoleteAddress = function(custId) {
//	  return;//Funktion deaktiviert
    var text = POS.lang.getText("MESSAGES", "CUSTOMER_ADDRESS_TOO_OLD");
    POS.message.show(text, "warning", "OK");
    var CustomerAdminClass = this;
    var r4 = Printer.head();
    $.when(r4).then(function() {
        var r = Trans.getCustomerData(custId);
        $.when(r).then(function(customerData) {

            CustomerAdminClass.printCustData("OLD", customerData);

            Printer.addLine("B", 1, false, 2);

            var r2 = Trans.getCustomerData(false);
            $.when(r2).then(function(custData) {

                CustomerAdminClass.printCustData("NEW", custData);

                var r3 = Trans.getEANFromCustId(custId)
                $.when(r3).then(function(EAN) {
                    Printer.addLine("B", 1, false, 1);
                    Printer.addBarcodeLine("AA", 2, 72, EAN, 1);
                    Printer.addLine("A", 1, false, 0);
                    Printer.addElement(EAN.toString(), 20, 2, true, 0, 41);
                    Printer.addLine("B", 1, false, 2);

                    var r5 = Printer.foot();
                    $.when(r5).then(function() {
                        Printer.print();
                    });
                });
            });
        });
    });
}

CCustomerAdmin.prototype.customerSearch = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var param = me.components.inputField.field.input.properties.attributes.value;

    if (!param) {
        var text = POS.lang.getText("MESSAGES", "NO_INPUT_DATA");
        POS.message.show(text, "warning", "OK");
        return;
    }

    //var paramDB = umlauToEntity(me.components.inputField.field.input.properties.attributes.value);
    var paramDB = String(param);
    paramDB = paramDB.replace(/\u00DF/g, "&szlig;");
    paramDB = paramDB.replace(/\u00DC/g, "&Uuml;");
    paramDB = paramDB.replace(/\u00C4/g, "&Auml;");
    paramDB = paramDB.replace(/\u00D6/g, "&Ouml;");
    /*privMan.enablePrivilege (privList);*/

    me.resetSQLConditions();

    me.SQLConditions["FirstName"] = "LIKE '%" + paramDB + "%'";
    me.SQLConditions["Surname"] = "LIKE '%" + paramDB + "%'";
    var sql = me.getSQLQuery();

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function(rows) {
        var j = 0;

        for (var i = 0; i < rows.length; i++) {
            var firstNameDB = rows[i].FirstName;
            var surnameDB = rows[i].Surname;
            var ZIPDB = rows[i].ZIP;
            //var nameSearch = entityToUmlau(firstNameDB) + entityToUmlau(surnameDB);
            var nameSearch = firstNameDB + surnameDB;
            var regExpParam = new RegExp(paramDB, "gi");

            if (nameSearch.match(regExpParam) != null) {
                me.foundCustomers.custId[j] = rows[i].Barcode;
                me.foundCustomers.custName[j] = "&nbsp;-&nbsp;" + ZIPDB + " / " +
                    firstNameDB + " " + surnameDB;

                j++;
            }

            //r.moveNext();
        }

        //r.free();

        if (me.foundCustomers.custId.length == 0) {
            var text = POS.lang.getText("MESSAGES", "NO_CUSTOMERS_FOUND");
            POS.message.show(text, "warning", "OK");
            me.components.inputField.field.input.properties.attributes.value = "";
            me.components.inputField.field.input.reAttribute();
            return;
        }

        me.components.inputField.field.input.properties.attributes.value = "";
        me.components.inputField.field.input.reAttribute();

        me.makeBodyList();
    });
}

CCustomerAdmin.prototype.numberSearch = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);
    var mode = parameters[1];

    var param = me.components.inputField.field.input.properties.attributes.value;

    if (!param) {
        var text = POS.lang.getText("MESSAGES", "NO_INPUT_DATA");
        POS.message.show(text, "warning", "OK");
        return;
    }

    param = new Number(param);

    me.components.inputField.field.input.properties.attributes.value = "";
    me.components.inputField.field.input.reAttribute();

    if (isNaN(param)) {
        var text = POS.lang.getText("MESSAGES", "INVALID_CUSTOMER_NUMBER");
        POS.message.show(text, "warning", "OK");
        return;
    } else
        param = parseFloat(param);

    /*privMan.enablePrivilege (privList);*/

    me.resetSQLConditions();

    me.SQLConditions[mode] = "LIKE '%" + param + "%'";
    var sql = me.getSQLQuery();

    var r = POS.SQLiteCon.execute(sql);
    $.when(r).then(function(rows) {
        //if (r.recordCount() == 0)
        if (rows.length == 0) {
            //r.free();
            var text = POS.lang.getText("MESSAGES", "NO_CUSTOMERS_FOUND");
            POS.message.show(text, "warning", "OK");
            return;
        }

        for (var i = 0; i < rows.length; i++) {
            me.foundCustomers.custId[i] = rows[i].Barcode;
            me.foundCustomers.custName[i] = "&nbsp;/&nbsp;" + rows[i].ZIP + "&nbsp;/&nbsp;" +
                rows[i].FirstName + " " + rows[i].Surname;

            //r.moveNext();
        }

        //r.free();

        me.makeBodyList();
    });
}

CCustomerAdmin.prototype.makeBodyList = function() {
    var bonGrid = this.components.listContainer.components.list;
    bonGrid.clear();

    if (this.foundCustomers.custId.length == 0)
        return;

    for (var j = 0; j < this.foundCustomers.custId.length; j++) {
        var columns = new Array();

        for (var i = 0; i < 4; i++) {
            var n = columns.push(new CColumn(0, 0));
        }

        columns[0].properties.styles.width = "80px";
        columns[0].properties.styles.textAlign = "right";

        columns[0].properties.value = this.foundCustomers.custId[j];
        columns[1].properties.value = this.foundCustomers.custName[j];

        bonGrid.addRowWithColumns(columns);
    }

    bonGrid.selectedRowIndex = 0;
    bonGrid.rows[0].row.properties.styles.backgroundColor = "#D9E2F0";
    this.components.listContainer.reDraw();

    this.foundCustomers.custId = new Array();
    this.foundCustomers.custName = new Array();
}

CCustomerAdmin.prototype.resetSearch = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.components.inputField.field.input.properties.attributes.value = "";
    me.components.inputField.field.input.reAttribute();

    me.resetSQLConditions();

    me.resetList();
}

CCustomerAdmin.prototype.resetList = function() {
    this.foundCustomers.custId = new Array();
    this.foundCustomers.custName = new Array();

    this.components.listContainer.components.list.clear();
    this.components.listContainer.reDraw();
}

CCustomerAdmin.prototype.cancel = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.finish();
}

CCustomerAdmin.prototype.finish = function() {
    this.Main.enableInputFocus();

    log.add(4, "Info", "Customer admin off", "");

    this.removeMe();
}

export { CCustomerAdmin };
